export const BillingConversionError = Object.freeze({
  STILL_LOADING: 'STILL_LOADING',
  UNSUPPORTED_OBJECT_TYPE: 'UNSUPPORTED_OBJECT_TYPE',
  NO_OBJECT_TYPE: 'NO_OBJECT_TYPE',
  NO_OBJECT_ID: 'NO_OBJECT_ID',
  OBJECT_NOT_FOUND: 'OBJECT_NOT_FOUND',
  NO_CREATE_ACCESS: 'NO_CREATE_ACCESS',
  FRACTIONAL_QUANTITY: 'FRACTIONAL_QUANTITY',
  UNSUPPORTED_CURRENCY: 'UNSUPPORTED_CURRENCY',
  NO_CURRENCY: 'NO_CURRENCY',
  MULTIPLE_CURRENCIES: 'MULTIPLE_CURRENCIES',
  LARGE_QUANTITY: 'LARGE_QUANTITY',
  PAST_START_DATE: 'PAST_START_DATE',
  RELATIVE_START_DATE: 'RELATIVE_START_DATE',
  FUTURE_ONE_TIME_LINE_ITEM: 'FUTURE_ONE_TIME_LINE_ITEM',
  MULTI_YEAR_BILLING_FREQUENCY: 'MULTI_YEAR_BILLING_FREQUENCY'
});